<template>
	<v-switch
		:label="label"
		v-model="checked"
		:dense="dense"
		:disabled="disabled"
		:value="value"
		:class="{
			'mt-0': dense,
			'pt-0': dense,
		}"
		@change="onChange($event)"
	/>
</template>

<script>
export default {
	props: {
		label: String,
		value: Boolean,
		dense: Boolean,
		disabled: Boolean,
	},
	data() {
		return {
			checked: false,
		}
	},
	created() {
		this.checked = this.value || false
	},
	watch: {
		value() {
			this.checked = this.value
		},
	},
	methods: {
		onChange(event) {
			this.$emit('input', event || false)
		},
	},
}
</script>
